<template>
  <div class="search-filters" :class="{'search-filters--tm4728': $store.getters.experimentChipsFiltersVisible }">
    <div class="h-full w-full flex search-filters__row">
      <div class="h-full w-full sm:w-auto flex sm:shrink-0">
        <PeopleOption
          class="search-filters__tab"
          :is-mobile="isMobile"
          data-test-id="people-search-filter"
        />
        <DateOption
          class="search-filters__tab grow"
          :is-mobile="isMobile"
          data-test-id="date-search-filter"
        />
        <PriceOption
          class="search-filters__tab"
          :is-mobile="isMobile"
          data-test-id="price-search-filter"
        />
      </div>
      <MoreOptions
        class="search-filters__tab search-filters__tab-more"
        :is-mobile="isMobile"
        data-test-id="more-search-filter"
      />
      <SearchChips v-if="($store.getters.experimentChipsFiltersVisible || $store.state.experimentChipsFiltersWasMounted) && !isMobile" />
    </div>
    <TagLocationOptions :is-mobile="isMobile" />
  </div>
  <div v-if="$store.getters.experimentChipsFiltersVisible && isMobile" class="search-chips--tm4728">
    <SearchChips />
  </div>
</template>

<script>
import throttle from 'lodash/throttle';

import SearchChips from '@/modules/public/search/components/FiltersAboveMapExperiment/SearchChips.vue';

import DateOption from './components/FiltersTabs/Date/DateOption.vue';
import MoreOptions from './components/FiltersTabs/More/MoreOptions.vue';
import PeopleOption from './components/FiltersTabs/People/PeopleOption.vue';
import PriceOption from './components/FiltersTabs/Price/PriceOption.vue';
import TagLocationOptions from './components/FiltersTabs/TagLocationOptions/TagLocationOptions.vue';

export default {
  name: 'SearchFilters',
  components: {
    TagLocationOptions,
    PeopleOption,
    DateOption,
    PriceOption,
    MoreOptions,
    SearchChips,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    setDeviceThrottle: throttle(async function () { // eslint-disable-line func-names
      this.setDevice();
    }, 300),
    setDevice() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile && this.desktopOpen) {
        this.desktopOpen = false;
        this.mobileOpen = true;
      }
      if (!this.isMobile && this.mobileOpen) {
        this.desktopOpen = true;
        this.mobileOpen = false;
      }
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.setDeviceThrottle);
  },
  mounted() {
    this.setDevice();
    window.addEventListener('resize', this.setDeviceThrottle);
  },
};
</script>

<style lang="scss" scoped>
  @use "@sass/design-system/variables" as ds-variables;
  @use "@sass/base/variables";

  $search-filters-height: 44px;

  .search-filters {
    height: $search-filters-height;
    display: flex;
    border-bottom: 1px solid ds-variables.$grey-300;
    background-color: ds-variables.$white;
  }

  .search-filters__tab {
    display: inline-block;
    height: 100%;

    &__button {
      background-color: inherit;
      border: none;
      height: 100%;
      width: 100%;
    }

    &.search-filters__tab-more,
    & + & {
      border-left: 1px solid ds-variables.$grey-300;
    }

    i {
      margin: 5px 0;
      font-weight: 800;
    }
  }
</style>

<style lang="scss">
@use "@sass/design-system/variables" as ds-variables;
@use "@sass/base/variables";
@use "@sass/design-system/base-header";

.v-search-page-filters {
  position: fixed;
  top: base-header.$header-height;
  left: 0;
  right: 0;
  z-index: 2000;
}

// mobile only section
.search-chips--tm4728 {
  height: 56px;
  border-bottom: 1px solid ds-variables.$grey-300;
  background-color: ds-variables.$white;
}

@media #{variables.$for-mobile} {
  .v-search-page-filters {
    top: base-header.$header-height-mobile;
  }

  .ds-header__main {
    flex-grow: 1;
  }

  #ds-header__actions {
    width: 100%;
  }

  .ds-header__main .vue-portal-target {
    flex-grow: 1;
  }
}

html {
  font-size: 16px;
}
.navbar {
  border-radius: 0;
}

.navbar-default {
  border-color: ds-variables.$grey-300;
}

*:focus {
  outline: none;
}
</style>
